import {inject} from 'mobx-react'
import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import {rootStore} from '../../mobx/store'
import strings from '../../lang/strings'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import {MenuMyData} from '../../config/page_route'
import {formatNumber} from '../../helper/common'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {FORMAT, PAGECOUNT} from '../../config/const'
import ReactPaginate from 'react-paginate'
import styles from './sale_list.module.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const SaleList = (props) => {
  const context = useContext(Page_settings)
  let [payList, setPayList] = useState([])
  let [totalCnt, setTotalCnt] = useState(0)
  let [payAmount, setPayAmount] = useState(0)
  let [payRefund, setPayRefund] = useState(0)
  let [pageCount, setPageCount] = useState(0)

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1)
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())


  const tbHeaders = [
    {
      name: strings.order_date,
      class: 'td-pay-order-date',
    },
    {
      name: strings.order_num,
      class: 'td-pay-order-num',
    },
    {
      name: strings.pdt_name,
      class: 'td-pay-pdt-name',
    },
    {
      name: strings.orderer_name,
      class: 'td-pay-orderer-name',
    },
    {
      name: strings.pay_date,
      class: 'td-pay-date',
    },
    {
      name: strings.pay_amount,
      class: 'td-pay-amount',
    },
    {
      name: strings.status,
      class: 'td-pay-status',
      divider: false
    },
  ]

  const active = 1

  useEffect(() => {
    getData(1, selectedYear, selectedMonth)
  }, [selectedMonth, selectedYear])

  const getData = (page, year, month) => {
    context.post('pay/sale_list', {page: page, count: PAGECOUNT, month:month, year:year},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setTotalCnt(response.total_cnt)
        setPayAmount(response.pay_amount)
        setPayRefund(response.refund_amount)
        setPayList(response.list)
        setPageCount(response.page_count)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const handlePageClick = (component) => {
    const nextPage = component.selected + 1
    getData(nextPage)
  }

  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12)
      setSelectedYear(selectedYear - 1)
    } else {
      setSelectedMonth(selectedMonth - 1)
    }
  }

  const handleNextMonth = () => {
    if (selectedMonth === 12) {
      setSelectedMonth(1)
      setSelectedYear(selectedYear + 1)
    } else {
      setSelectedMonth(selectedMonth + 1)
    }
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMyData} active={active} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.sale_list} pageMenu1={strings.main} pageMenu2={strings.my_analyst} pageMenu={strings.sale_list}/>


          <div className={`${styles.monthSelector}`}>
            <button onClick={handlePrevMonth} className={`${styles.arrowBtn}`}><FaChevronLeft /></button>
            <span className={styles.monthText}>{selectedYear}년 {selectedMonth}월</span>
            <button onClick={handleNextMonth} className={`${styles.arrowBtn}`}><FaChevronRight /></button>
          </div>

          <div className='term-content-area d-flex p-0 fs-14 sm-fs-12 f-m'>
            <div className='flex-full sale-content'>
              <div className=''>{strings.total_order_num}</div>
              <div className='d-flex align-items-center mt-6'>
                <div className='fs-22 sm-fs-16 color-0a3962 f-sb'>{formatNumber(totalCnt)}</div>
                <div className=''> {strings.gon}</div>
              </div>
            </div>
            <div className='title-divider2' />
            <div className='flex-full sale-content'>
              <div className=''>{strings.sale_pay_amount}</div>
              <div className='d-flex align-items-center mt-6'>
                <div className='fs-22 sm-fs-16 color-0a3962 f-sb'>{formatNumber(payAmount + payRefund)}</div>
                <div className=''> {strings.won}</div>
              </div>
            </div>
            <div className='title-divider2' />
            <div className='flex-full sale-content'>
              <div className=''>{strings.sale_refund_amount}</div>
              <div className='d-flex align-items-center mt-6'>
                <div className='fs-22 sm-fs-16 color-0a3962 f-sb'>{formatNumber(payRefund)}</div>
                <div className=''> {strings.won}</div>
              </div>
            </div>
            <div className='title-divider2' />
            <div className='flex-full sale-content'>
              <div className=''>{strings.sale_may_amount}</div>
              <div className='d-flex align-items-center mt-6'>
                <div className='fs-22 sm-fs-16 color-0a3962 f-sb'>{formatNumber(payAmount)}</div>
                <div className=''> {strings.won}</div>
              </div>
            </div>
          </div>
          <div className='shadow-div position-relative'>
            <PerfectScrollbar className='tb-sale mt-60 sm-mt-30 mb-40'>
              <TableHeader className={'hx-48'} headers={tbHeaders} />
              {
                payList.map((info, index) => {
                  return (
                    <div key={index} className='tb-row cursor-point hx-70'>
                      <TableCell
                        value={info.buy_createdat.dateFormat(FORMAT.DATE_TIME)}
                        className={tbHeaders[0].class}
                        center={tbHeaders[0].center}
                        child={null}
                      />
                      <TableCell
                        value={info.buy_id}
                        className={tbHeaders[1].class}
                        center={tbHeaders[1].center}
                        child={null}
                      />
                      <TableCell
                        value={info.buy_title}
                        className={tbHeaders[2].class}
                        center={tbHeaders[2].center}
                        child={null}
                      />
                      <TableCell
                        value={info.buy_name}
                        className={tbHeaders[3].class}
                        center={tbHeaders[3].center}
                        child={null}
                      />
                      <TableCell
                        value={info.buy_updatedat.dateFormat(FORMAT.DATE_TIME)}
                        className={tbHeaders[4].class}
                        center={tbHeaders[4].center}
                        child={null}
                      />
                      <TableCell
                        value={formatNumber(info.buy_po)}
                        className={tbHeaders[5].class}
                        center={tbHeaders[5].center}
                        child={null}
                      />
                      <TableCell
                        value={info.buy_status == 0 ? strings.waiting : (info.buy_status == 1 ? strings.complete : strings.refund)}
                        className={tbHeaders[6].class}
                        center={tbHeaders[6].center}
                        child={null}
                      />
                    </div>
                  )
                })
              }
            </PerfectScrollbar>
          </div>
          {pageCount > 1 &&
          <ReactPaginate
            previousLabel={''}
            nextLabel={''}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(inject('rootStore')(SaleList))
